<template>
  <div>
    <right-panel class="float-right" id="sidebar-new-process" width="600px" :icon="'mdi mdi-plus'" :text="$t('process.new')" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form />
      </div>
    </right-panel>

    <h2 v-if="parentEntity" v-html="$t('process.owned-list', { name: $options.filters.translate(parentEntity.name) })"></h2>

    <nav class="breadcrumb" v-if="parentEntity">
      <a class="breadcrumb-item" href="/organization">
        {{ $t("organization.text") }}
      </a>

      <a class="breadcrumb-item" href="javascript:;">
        {{ parentEntity.name | translate }}
      </a>

      <a class="breadcrumb-item text-muted" href="javascript:;">
        {{ $t("process.plural") }}
      </a>
    </nav>

    <table class="table project-list-table table-centered table-borderless compact ">
      <tr>
        <th scope="col" style="width:300px">
          <sortable-table-head field="name" :text="$t('process.name')" tag="span" :request="request" />
        </th>
        <th scope="col" style="width:300px">{{ $t("process-category.text") }}</th>

        <th scope="col" style="width: 15%">
          <a href="javascript:;" @click="toggleFilter">
            <span v-if="filterEnabled" class="text-warning">
              <i class="bx bxs-filter-alt"></i>
              {{ $t("common.filters-hide") }}
            </span>
            <span v-else class="text-muted">
              <i class="bx bxs-filter-alt"></i>
              {{ $t("common.filters-show") }}
            </span>
          </a>
        </th>
      </tr>

      <tr v-if="filterEnabled">
        <th><input class="form-control " v-model="nameFilter" :placeholder="$t('common.search')" /></th>

        <th>
          <filter-select
            id="categoryFilter"
            ref="categoryFilter"
            :placeholder="$t('process-category.text')"
            :multiple="false"
            @filter="onCategorySearch"
            @changed="onCategorySelect"
          />
        </th>

        <th></th>
      </tr>
    </table>

    <div v-if="pagination" class="row">
      <div class="col-2 hider font-small" v-for="item in pagination.docs" :key="item._id">
        <div class="card text-center p-2" v-bind:class="{ 'bg-success': item.completed }" :id="'popover-target-' + item._id">
          <b-popover :target="'popover-target-' + item._id" triggers="hover" placement="bottom" variant="secondary">
            <template #title> {{ $t("process.admins") }}</template>

            <table>
              <tr v-for="admin in item.admins" :key="'currentAdmins' + admin._id">
                <td><letter-avatar :name="admin.account.name" :image="admin.account.avatar" variant="secondary" /></td>
                <td>{{ admin.account.name }}</td>
              </tr>
            </table>
          </b-popover>

          <div @click="routerPush(item)">
            <div class="mt-2 text-truncate hand">
              <h6 v-b-tooltip.hover :title="$options.filters.translate(item.name)">
                {{ item.process.name | translate }}
              </h6>
              <span v-if="item.department" class="mb-0 text-muted">
                {{ item.department.name | translate }}
              </span>
              <span v-else class="text-light-gray" v-b-tooltip.hover :title="$t('process.no-department')">
                {{ $t("process.no-department") }}
              </span>
            </div>
          </div>
          <div v-if="hasUpdatePermission || hasRemovePermission" class="hidden">
            <div class="d-flex mt-3 team-social-links">
              <div v-if="hasUpdatePermission" class="flex-fill">
                <a @click="edit(item)" v-b-toggle="'sidebar-edit-organization-department'" v-b-tooltip.hover :title="$t('common.edit')">
                  <i class="bx bx-pencil text-primary"></i>
                </a>
              </div>

              <div v-if="hasRemovePermission" class="flex-fill">
                <a href="javascript:;void(0);" @click="deleteById(item)" v-b-tooltip.hover :title="$t('common.delete')">
                  <i class="bx bx-trash-alt text-danger"></i>
                </a>
              </div>
              <div class="flex-fill mt-1" v-b-tooltip.hover :title="$t('common.completed')">
                <b-form-checkbox switch size="sm" :checked="item.completed" @change="markAsComplete(item)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <content-loading v-if="isLoading" />

    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center">
        {{ $t("process.no-process") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import Form from "./organization-department-process-form";

export default {
  components: { Form },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      categoryFilter: undefined,
      filterEnabled: false,
    };
  },
  computed: {
    selectedEntity() {
      return this.$store.getters["organizationDepartmentProcess/selectedEntity"];
    },
    parentEntity() {
      return this.$store.getters["organizationDepartment/selectedEntity"];
    },
    pagination() {
      return this.$store.getters["organizationDepartmentProcess/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationDepartmentProcess/isLoading"];
    },
    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },
  },
  watch: {
    "$route.params.department": {
      immediate: true,
      handler() {
        this.fetchParent();
      },
    },

    request: {
      deep: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
  },
  mounted() {},
  methods: {
    async fetchParent() {
      this.$store.commit("organizationDepartment/selectedEntity", undefined);
      this.$store.commit("organizationDepartmentProcess/pagination", undefined);

      const parentId = this.$route.params.department;
      if (parentId) {
        await this.$store.dispatch("organizationDepartment/findById", parentId);
      }
      this.paginate();
    },
    async paginate() {
      const request = { ...this.request };
      if (this.parentEntity) {
        request.query = {
          ...request.query,
          department: { value: { _id: this.parentEntity._id }, isObject: true },
        };
      }

      await this.$store.dispatch("organizationDepartmentProcess/paginate", request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDepartmentProcess/delete", item._id);
        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    async markAsComplete(item) {
      try {
        await this.$store.dispatch("organizationDepartmentProcess/markAsComplete", item._id);
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    edit(item) {
      this.$store.commit("organizationDepartmentProcess/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-process");
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;

      if (!this.filterEnabled) {
        this.request = {
          options: { page: 1, limit: 15, sort: { name: "asc" } },
          query: {},
        };
        this.nameFilter = undefined;
        this.categoryFilter = undefined;
      }
    },

    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationProcessCategory/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onCategorySelect(item) {
      if (item && Object.keys(item).length) {
        this.request.query = {
          ...this.request.query,
          category: { value: item._id, isObject: true },
        };
      } else {
        this.request.query["category"] = null;
        delete this.request.query["category"];
      }
    },
    routerPush(item) {
      this.$router.push("/process-datasource/" + item._id);
    },
    rightPanelClosed() {
      this.paginate();
      this.$store.commit("organizationDepartmentProcess/editedEntity");
      this.$store.commit("organizationDepartmentProcess/copingEntity");
      // this.$store.dispatch("organizationDepartmentProcess/resetForm");
    },
  },
};
</script>
